import { render } from "./CreateDriveoff.vue?vue&type=template&id=51f68cda&scoped=true"
import script from "./CreateDriveoff.vue?vue&type=script&lang=js"
export * from "./CreateDriveoff.vue?vue&type=script&lang=js"

import "./CreateDriveoff.vue?vue&type=style&index=0&id=51f68cda&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f68cda"]])

export default __exports__